import { handleActions } from "redux-actions";
import { SelectionBlackList, ISelectionState, SelectionWhiteList } from "helpers/selection-state";
import { List } from "immutable";

import {
    BULK_ITEMS_ADD,
    BULK_ITEMS_CLEAR,
    BULK_ITEMS_DESELECT_ALL,
    BULK_ITEMS_REMOVE,
    BULK_ITEMS_SELECT_ALL,
    PAGE_LEAVE,
    BULK_ITEMS_SELECT,
} from "constants/action-types";

const initialState = new SelectionWhiteList();

const catalogReducer = handleActions(
    {
        [BULK_ITEMS_ADD]: (state: ISelectionState, { payload }: { payload: string }) => state.add(payload),
        [BULK_ITEMS_REMOVE]: (state: ISelectionState, { payload }: { payload: string }) => state.delete(payload),
        [BULK_ITEMS_CLEAR]: () => new SelectionWhiteList(),
        [BULK_ITEMS_SELECT_ALL]: () => new SelectionBlackList(),
        [BULK_ITEMS_DESELECT_ALL]: () => new SelectionWhiteList(),
        [BULK_ITEMS_SELECT]: (_state, { payload }: { payload: string[] }) =>
            new SelectionWhiteList(List(payload).toOrderedSet()),
        [PAGE_LEAVE]: () => initialState,
    } as any,
    initialState
);

export default catalogReducer;
